module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('div', {
    staticClass: "center50",
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/Spooky_Page19A.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "frontmatter_dedication"
  }), _vm._v(" "), _c('p', {
    staticClass: "frontmatter_dedication"
  }, [_vm._v("Dedication")]), _vm._v(" "), _c('p', {
    staticClass: "frontmatter_dedication"
  }, [_vm._v("To Rafi, Henrik, Greta, and Fredrik ")]), _vm._v(" "), _c('p', {
    staticClass: "frontmatter_dedication"
  }), _vm._v(" "), _c('p', {
    staticClass: "frontmatter_dedication"
  }, [_vm._v("To the courthouse dogs")]), _vm._v(" "), _c('p', {
    staticClass: "frontmatter_dedication"
  }, [_vm._v("Thank you for good work you do")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ef15099","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HelperHounds_Bk6_Spooky.vue
// module id = 57
// module chunks = 0